import {UiRouterFasade, UiRouterState} from "felles/infrastruktur/UiRouterFasade";
import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {TransitionService, UIRouterGlobals} from "@uirouter/angularjs";
import {StateDeclaration} from "@uirouter/core/lib/state/interface";
import {Kontekst} from "felles/tjenester/Kontekst";
import {IScope} from "angular";
import {Transition} from "@uirouter/core/lib/transition/transition";


export class UiRouterWebFasade extends UiRouterFasade {

    static forInjisering() {
        return [regNavn.ng.ui.$uiRouterGlobals, regNavn.ng.ui.$transitions, regNavn.ng.$rootScope, Kontekst.regNavn, UiRouterWebFasade];
    }

    constructor(private $uiRouterGlobals: UIRouterGlobals, private $transitions: TransitionService, $rootScope: IScope, kontekst:Kontekst) {
        super($rootScope, kontekst);
    }

    currentState(): UiRouterState {
        return new UiRouterWebState(this.$uiRouterGlobals.current);
    }

    registrerStateAutoriasasjonsHåndtering(harTilgang: (fra: UiRouterState, til: UiRouterState) => boolean) {
        this.$transitions.onBefore({}, (transition: Transition) => {
            if (harTilgang(new UiRouterWebState(transition.from()), new UiRouterWebState(transition.to()))) return;
            return false; //false avbryter state transition
        });
    }
}

export class UiRouterWebState extends UiRouterState{
    constructor(state:StateDeclaration) {
        super();
        this.name = state.name;
        this.tilgangsroller = state.data?.tilgangsroller;
        this.url = state.url;
    }
}
